import { render, staticRenderFns } from "./LayoutData.vue?vue&type=template&id=1659f46e&"
import script from "./LayoutData.vue?vue&type=script&lang=js&"
export * from "./LayoutData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports